import { NumberInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventPointsInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { pointsPerEvent } = values;

    const updateValue = (value: number | string) => {
        updateValues({
            ...values,
            pointsPerEvent: Number(value) || 0,
        });
    };

    return (
        <NumberInput
            id="event-points-input"
            label={intl.formatMessage(sharedMessages.pointsPerEvent)}
            placeholder={intl.formatMessage(sharedMessages.pointsPerEventPlaceholder)}
            min={0}
            max={128}
            onChange={updateValue}
            value={pointsPerEvent}
            required
            radius="md"
            size="md"
        />
    );
};

export default EventPointsInput;
